// Vuetify
import 'vuetify/styles'
import {createVuetify} from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VCalendar } from 'vuetify/labs/VCalendar';
import { VTimePicker } from 'vuetify/labs/VTimePicker'
import { createApp } from 'vue'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

// Styles
// import 'styles/main.css';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import 'vue3-swatches/dist/style.css'

// Init
import App from './App.vue'
import {Store} from 'vuex';
import router from './router';
import store from './store';

// Middlewares, plugins
import {Logger} from '@/plugins/Logger';
import {Vuetify3Dialog} from "vuetify3-dialog";
import {Plugin} from "@vue/runtime-core";
import VSwatches from "vue3-swatches";

const vuetify = createVuetify({
    components: {
        ...components,
        VCalendar,
        VTimePicker,
    },
    directives,
});

const app = createApp(App);
app.component('QuillEditor', QuillEditor);

app
    .use(vuetify)
    .use(store)
    .use(Vuetify3Dialog)
    .use(router)
    .use(Logger)
    .use(VSwatches)
    .mount('#app');
